var map = {
	"./img_0.png": 700,
	"./img_1.png": 701,
	"./img_10.png": 702,
	"./img_2.png": 703,
	"./img_3.png": 704,
	"./img_4.png": 705,
	"./img_5.png": 706,
	"./img_6.png": 707,
	"./img_7.png": 708,
	"./img_8.png": 709,
	"./img_9.png": 710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 699;